import API from "./index";

// get all property
const getAllProperty = async (filters = {}) => {
  try {
    const { data } = await API.get("/property", {
      params: filters,
    });
    return data;
  } catch (error) {
    // Handle error
    console.error("Error fetching property data:", error);
    return null;
  }
};

// get single property
const getSingleProperty = async (propertyId) => {
  const { data } = await API.get(`property/${propertyId}`);
  return data;
};

// create property
const createProperty = async (params) => {
  try {
    const { data } = await API.post("/property", params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return data;
  } catch (error) {
    console.error("Error fetching property data:", error);
  }
};

// update property
const updateProperty = async (params, propertyId) => {
  try {
    const { data } = await API.patch(`/editProperty/${propertyId}`, params, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return data;
  } catch (error) {
    console.error("Error fetching property data:", error);
  }
};

// delete property
const deleteProperty = async (propertyId) => {
  try {
    const { data } = await API.delete(`/deleteProperty/${propertyId}`);
    return data;
  } catch (error) {
    console.error("Error deleteing property data:", error);
  }
};

export {
  getAllProperty,
  getSingleProperty,
  createProperty,
  updateProperty,
  deleteProperty,
};
